/**
 * @desc cookie操作
 * @author ruoxinhuang
 * @date 2021-09-09
 */
import Cookie from 'js-cookie';
export function setCookie(key, value) {
    // 为了调试方便,  http 页面下不要用 secure 模式
    var secure = location.protocol === 'https:' ? true : undefined;
    var firstSpliterIndex = window.location.host.indexOf('.');
    var domain = window.location.host.substr(firstSpliterIndex);
    Cookie.set(key, value, {
        secure: secure,
        domain: domain,
        path: '/',
    });
}
